import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/MercadoAustralianoOQueComprar";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/mercado-australiano-o-que-comprar")({
  head: () =>
    pageHead({
      title: "Mercado australiano: o que comprar no Coles, Woolies e Aldi | Clara Camille",
      description:
        "O que comprar no Coles, Woolworths e Aldi para comer bem gastando pouco: equivalentes dos produtos brasileiros, como ler rótulos em inglês e lista básica.",
      path: "/mercado-australiano-o-que-comprar",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([{ name: "Mercado australiano: o que comprar", path: "/mercado-australiano-o-que-comprar" }]),
      ],
    }),
  component: Page,
});
